import React from "react"
import { ContactTextInputContainer, GeneralTypeSelect } from "./style"
import { ErrorMsgSpan } from "components/TextInput/style"
import { Img } from "globalStyles"
import { ArrowSelectDown } from "utils/assets"

function CustomSelectMain({ children, value, onChange, label, name, mt = "", width = "100%", error, visible, ErrorMt, ...rest }) {
	return (
		<ContactTextInputContainer mt={mt} width={width}>
			<label htmlFor={name}>{label}</label>
			<GeneralTypeSelect>
				<select value={value} onChange={onChange} name={name} {...rest}>
					{children}
				</select>
				<div>
					<Img width="12px" height="12px" src={ArrowSelectDown} alt="select" />
				</div>
			</GeneralTypeSelect>
			{visible && error ? <ErrorMsgSpan ErrorMt={`${mt}`}>{error}</ErrorMsgSpan> : null}
		</ContactTextInputContainer>
	)
}
export function SelectField({ children, value, onChange, label, name, error, visible, ErrorMt, ...rest }) {
	return (
		<div className="mb-2">
			<label className="font-medium block mb-1" htmlFor={name}>{label}</label>
				<select className="p-3 border w-full py-2" value={value} onChange={onChange} name={name} {...rest}>
					{children}
				</select>
			{visible && error ? <div className="text-sm text-red-500">{error}</div> : null}
		</div>
	)
}

export default CustomSelectMain
